export default __webpack_public_path__ + "static/media/offer-3-2f8285b13bef950f843cb4147666af6e.8d18e447.png";